import { render } from "./ExpandTextBox.vue?vue&type=template&id=2d6c0fe3&scoped=true"
import script from "./ExpandTextBox.vue?vue&type=script&lang=js"
export * from "./ExpandTextBox.vue?vue&type=script&lang=js"

import "./ExpandTextBox.vue?vue&type=style&index=0&id=2d6c0fe3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6c0fe3"]])

export default __exports__